import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

// Import your award certificate images
import socialmediacontent from "../../assets/social-media-content.png";
import IntegratedDigitalCampaign from "../../assets/Integrated-Digital-Campaign.png";

const awards = [
    {
      title: "Best Social Media Content",
      date: "2022",
      description:
        "Celebrated for scaling the channel to 5M subscribers, driven by a powerful content strategy and metadata optimisation.",
      image: socialmediacontent,
    },
    {
      title: "Best Integrated Digital Campaign (Entertainment)",
      date: "2023",
      description:
        "Honoured for leading an integrated digital campaign for a movie launch under Discovery Kids India, delivering a standout performance across platforms.",
      image: IntegratedDigitalCampaign,
    },
  ];  

export function Awards() {
  return (
    <Container id="awards">
      <h2>Awards</h2>
      <div className="award-grid">
        {awards.map((award, index) => (
          <ScrollAnimation animateIn="fadeInUp" delay={index * 100} key={index}>
            <div className="award-card">
              <img src={award.image} alt={award.title} className="award-image" />
              <div className="award-info">
                <h3>{award.title}</h3>
                <p><strong>{award.date}</strong></p>
                <p>{award.description}</p>
              </div>
            </div>
          </ScrollAnimation>
        ))}
      </div>
    </Container>
  );
}
